import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationService } from '../../services/navigation.service';
import { NavigationItem } from '../../../shared/models/navigation-item';
import { OroService, EventTyp } from '../../../oroservice';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DateAdapter } from '@angular/material/core';
import { DocumentService } from '../../../shared/services/document.service';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    standalone: false
})
export class NavigationComponent implements OnInit {

    navigationItem: NavigationItem;
    currentGp: number = 0;

    constructor(private navigation: NavigationService, public oroservice: OroService, private readonly documentService: DocumentService, private translate: TranslateService,
        public cookieservice: CookieService, public _router: Router, private dialogRef: MatDialog, private _adapter: DateAdapter<any>) {
        this.oroservice.onChange.subscribe({
            next: (event: EventTyp) => { }
        })
    }

    public get documentCount(): number {
        return this.documentService.documentCount;
    }

    @HostListener('window:focus', ['$event'])
   onFocus(event: FocusEvent): void {
        const storedEmail = this.cookieservice.get("email");

        if (!this.oroservice.kundeninfo.Email && this._router.url.includes("/?")) {
            // Token activation, password reset, etc...
            return;
        }

        if (storedEmail !== this.oroservice.kundeninfo.Email) {
            this.dialogRef.closeAll();
            this.oroservice.IsLoggedIn = false;
            this._router.navigate(['/']);
        }
   }

    ngOnInit() {
        this.currentGp =  +this.oroservice.getGp();


        this.navigation.change.subscribe((item: NavigationItem) => this.navigationItem = item);
        this.oroservice.setCurrentGp(this.currentGp);
    }

    public async selectOrder(): Promise<void> {
        if (!await this.oroservice.checkNewOrderAccess()) {
            return;
        }

        await this._router.navigate(['Auftrag']);
    }

    SetDE() {
        this.translate.use('de');
        this.cookieservice.set('lang', 'de');
        this._adapter.setLocale('de-CH');
        document.title = "My Inkas Kundenportal";
        this.oroservice.settingscurrent = this.oroservice.settingsde;
        if (this.oroservice.IsLoggedIn) {
            this.oroservice.getKundenInfo();
        }
    }
    SetFR() {
        this.translate.use('fr');
        this.cookieservice.set('lang', 'fr');
        this._adapter.setLocale('fr-CH');
        document.title = "FR.My Inkas Kundenportal";
        this.oroservice.settingscurrent = this.oroservice.settingsfr;
        if (this.oroservice.IsLoggedIn) {
            this.oroservice.getKundenInfo();
        }
    }
    SetIT() {
        this.translate.use('it');
        this.cookieservice.set('lang', 'it');
        this._adapter.setLocale('it-CH');
        document.title = "IT.My Inkas Kundenportal";
        this.oroservice.settingscurrent = this.oroservice.settingsit;
        if (this.oroservice.IsLoggedIn) {
            this.oroservice.getKundenInfo();
        }
    }

    Logout() {
        //this.oroservice.IsLoggedIn = false;
        this.oroservice.setLogout();
        this.onFocus(null);
        //this._router.navigate(['/']); //, { queryParams: { Logout: 1 } });
        //window.location.href ="/app?Logout=1";
    }

    reloadroute(value: number) {
        this.oroservice.setCurrentGp(value);

        this._router.navigate(['Empty']);
        setTimeout(() => {
            /** spinner ends after 5 seconds */
            this._router.navigate(['/Startseite']);
        }, 1);
    }

    changeGp() {
        this.reloadroute(this.currentGp);
    }

    public isGpSelected(gp : number) : boolean{
        return gp.toString() === this.oroservice.getGp();
    }

    public navigate(target: string) {
        this._router.navigate([target]);
    }
}
